import PropTypes from 'prop-types';

import Radio from '../Radio';

const BooleanInput = ({ name, ...otherProps }) => (
  <Radio
    type="input"
    name={name}
    inputs={[
      {
        dataTestId: `${name}_yes`,
        id: `${name}_yes`,
        label: __('Yes'),
        name: `${name}_yes`,
        value: true,
      },
      {
        dataTestId: `${name}_no`,
        id: `${name}_no`,
        label: __('No'),
        name: `${name}_no`,
        value: false,
      },
    ]}
    {...otherProps}
  />
);

BooleanInput.propTypes = {
  ...Radio.propTypes,
  inputs: PropTypes.any,
};

export default BooleanInput;
